/**
 * AdminTeam — manage management team members shown on About page.
 */
import AdminCrudPage from "./AdminCrudPage";

const fields = [
  { name: "name", label: "Full Name", type: "text" },
  { name: "role", label: "Role / Designation (e.g. Managing Director)", type: "text" },
  { name: "photo", label: "Profile Photo (round frame)", type: "image" },
  { name: "bio", label: "Short Bio / About", type: "textarea", rows: 4 },
  { name: "linkedin", label: "LinkedIn URL (optional)", type: "text" },
  { name: "order", label: "Display Order (lower = first)", type: "number" },
  { name: "visible", label: "Visible on About page", type: "boolean" },
];

const columns = [
  { key: "name", label: "Name" },
  { key: "role", label: "Role" },
  { key: "order", label: "Order" },
  { key: "visible", label: "Visible", render: (it) => (it.visible ? "Yes" : "No") },
];

export default function AdminTeam() {
  return (
    <AdminCrudPage
      title="Team"
      endpoint="team"
      columns={columns}
      fields={fields}
      initial={{ name: "", role: "", photo: "", bio: "", linkedin: "", order: 0, visible: true }}
    />
  );
}
